const animator = {

	elem: {
		animateLoad: document.querySelectorAll('.animate-load'),
		animateOnce: document.querySelectorAll('.animate-once'),
		animatePrevious: document.querySelectorAll('.animate-previous')
	},

	animationOnceObserver: null,
	animationPreviousObserver: null,	

	init() {
		// when the page has loaded, animate anything with the animate-load state
		if (animator.elem.animateLoad.length > 0) {
			animator.elem.animateLoad.forEach(function(element) {
				element.classList.remove('animate-load');
			});
		}

		// observe all other animated elements so that they only animate when intersecting
		if (animator.elem.animateOnce.length > 0) {
			animator.animationOnceObserver = new IntersectionObserver(animator.animateOnce, { root: null, rootMargin: '-100px 0px', threshold: 0 });			
			animator.elem.animateOnce.forEach(function(element) {
				element.classList.add('animate-start');				
				animator.animationOnceObserver.observe(element);
			});
		}		

		if (animator.elem.animatePrevious.length > 0) {
			animator.animationPreviousObserver = new IntersectionObserver(animator.animatePrevious, { root: null, rootMargin: '-100px 0px', threshold: 0 });			
			animator.elem.animatePrevious.forEach(function(element) {
				element.classList.add('animate-start');				
				animator.animationPreviousObserver.observe(element);
			});
		}			
	},

	// animateOnce(): when an entry meets the intersection criteria, trigger the animation end state and stop observing it
	animateOnce(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				entry.target.classList.add('animate-end');
				animator.animationOnceObserver.unobserve(entry.target);
			}
		});
	},

	// animatePrevious(): when an entry meets the intersection criteria, trigger the animation end state on the previous element and stop observing the current element
	animatePrevious(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				entry.target.classList.add('animate-middle');
				if (entry.target.previousElementSibling !== null) {
					entry.target.previousElementSibling.classList.add('animate-end');
				}
				animator.animationPreviousObserver.unobserve(entry.target);
			}
		});
	}
	
};

export { animator };
